import api from '../../services/api';
import { buildApiHeaders } from '../../utilities/configUtils';

export const fetchAssetGroupsInitialState = async () => {
  try {
    const headers = await buildApiHeaders();
    return await api
      .get('Assets?groupBy=AssetGroupName', {
        headers,
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      });
  } catch (error) {
    console.error('Error fetching initial state:', error);
    return [];
  }
};
